function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.9,
  fill: "#BCD7F6",
  d: "M2 0C0.895431 0 0 0.895431 0 2V6C0 7.10457 0.895431 8 2 8H29.1755L29.2672 7.83541C29.8009 6.82475 31.2156 6 32.3136 6H34.6892H36V2C36 0.895431 35.1046 0 34 0H2Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.6,
  fill: "#BCD7F6",
  d: "M26.9383 12H2C0.895431 12 0 12.8954 0 14V18C0 19.1046 0.895431 20 2 20H22.4901L26.9383 12Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.3,
  fill: "#BCD7F6",
  d: "M22.4955 24H2C0.895431 24 0 24.8954 0 26V30C0 31.1046 0.895431 32 2 32H26.9391L23.9033 26.5223L22.4955 24Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2.5,
  stroke: "white",
  d: "M50.9896 21.7472C51.0035 21.9132 51.0035 22.0812 50.9896 22.2464C50.9613 22.62 50.8722 22.9815 50.7161 23.2668L49.6692 25.1091L46.833 30.1352C46.7923 30.2292 46.7467 30.3175 46.6776 30.3944C46.6735 30.4001 46.6688 30.4048 46.6642 30.4096C46.6595 30.4143 46.6548 30.4191 46.6507 30.4248L45.909 31.7297C45.5368 32.4273 44.5479 33 43.771 33H42.0956H35.9059H34.2306C33.4537 33 32.4648 32.4273 32.0925 31.7297L31.3515 30.4248C31.3474 30.4191 31.3425 30.4143 31.3377 30.4096C31.3329 30.4048 31.3281 30.4001 31.3239 30.3944C31.2549 30.3175 31.2093 30.2292 31.1685 30.1352L28.3323 25.1091L27.2854 23.2668C27.1321 22.9871 27.0423 22.6369 27.0119 22.2718C26.996 22.0897 26.996 21.9047 27.0119 21.7225C27.0423 21.3574 27.1314 21.0065 27.2854 20.7269L31.1699 13.8655C31.1876 13.8136 31.2207 13.7685 31.2539 13.7234C31.2609 13.7138 31.268 13.7042 31.2749 13.6946L32.087 12.2618C32.4606 11.567 33.4509 11 34.2195 11H35.8824H42.1177H43.7806C44.5493 11 45.5396 11.567 45.9131 12.2618L46.7253 13.6946C46.7331 13.7057 46.7411 13.7167 46.7492 13.7278C46.7811 13.7714 46.8131 13.8153 46.8302 13.8655L50.7148 20.7269C50.8722 21.0122 50.9613 21.3737 50.9896 21.7472Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var SvgIconPoolsEmpty2 = function SvgIconPoolsEmpty2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 54 38",
    height: 38,
    width: 54,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPoolsEmpty2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_PoolsEmpty2.a40766c7.svg";
export { ForwardRef as ReactComponent };